export default "__VITE_ASSET__DFIIT1ja__"